<template>
  <div>
    <div class="row" v-if="$store.state.user.access_nivel == 6">
      <div class="col-md-12">
        <button class="btn btn-primary mb-2" @click="importNotifications">
          Importar Notificações de Agravos
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'notificationInjuriesCrud'"
          crudName="Notificações de Agravos"
          newText="Nova Notificação de Agravo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "notificationInjuries",
      showMessageImport: false,
      notificationInjuriesCrud: {},
      pages: [],
      url: "",
      columns: ["id", "title", "actions"],
      tableData: ["id", "title"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "title"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "notification_injuries",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    importNotifications() {
      let self = this;
      let api = self.$store.state.api + "notification_injuries/import";

      axios
        .post(api)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Notificações de Agravos importadas com sucesso`,
            "success"
          );
          self.$refs.notificationInjuriesCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>